import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TranslationsModule } from '@symplicity/syng';
import { ReSubscribeModalComponent } from './resubscribe-modal/resubscribe-modal.component';
import { SubscribFailModalComponent } from './subscribefail-modal/subscribefail-modal.component';
import { UnsubscribeModalComponent } from './unsubscribe-modal/unsubscribe-modal.component';
import { UnsubscribeRoutingModule } from './unsubscribe-routing.module';
import { UnsubscribeComponent } from './unsubscribe.component';

@NgModule({
    imports: [
        UnsubscribeRoutingModule,
        TranslationsModule.forChild(),
        TranslateModule,
    ],
    declarations: [
        UnsubscribeComponent,
        ReSubscribeModalComponent,
        SubscribFailModalComponent,
        UnsubscribeModalComponent
    ]
})
export class UnsubscribeModule {}
